/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pure_Clear_Deer_NestInputs */

const en_pure_clear_deer_nest = /** @type {(inputs: Pure_Clear_Deer_NestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search segments...`)
};

const de_pure_clear_deer_nest = /** @type {(inputs: Pure_Clear_Deer_NestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segmente suchen...`)
};

/**
* | output |
* | --- |
* | "Search segments..." |
*
* @param {Pure_Clear_Deer_NestInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pure_clear_deer_nest = /** @type {((inputs?: Pure_Clear_Deer_NestInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pure_Clear_Deer_NestInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pure_clear_deer_nest(inputs)
	return de_pure_clear_deer_nest(inputs)
});